<template>
  <div class="element-box content-box">
    <div class="support-ticket-content-header mb-0">
      <a class="back-to-index" @click="regresarClick" style="color: blueviolet">
        <i class="os-icon os-icon-arrow-left5"></i>
        <span>Regresar</span>
      </a>
    </div>
    <div class="support-ticket-content"></div>
    <div class="floated-colors-btn second-floated-btn" style="z-index: 1010 !important" @click="cambiarUiTabla">
      <div class="os-toggler-w" :class="{ on: cambiar_UiTabla }">
        <div class="os-toggler-i">
          <div class="os-toggler-pill"></div>
        </div>
      </div>
      <span v-if="!cambiar_UiTabla">Tabla normal</span>
      <span v-if="cambiar_UiTabla">Tabla mini</span>
    </div>
    <div class="row mt-2">
      <div class="col-lg-12">
        <div class="padded-lg">
          <div class="ticket-content">
            <div class="text-center">
              <h5>
                <b>Tarima #{{ current.numero }}</b>
              </h5>
              <span class="badge" :class="{
                'badge-success': current.estado == 'A',
                'badge-warning': current.estado == 'B',
                'badge-danger': current.estado == '9',
              }">{{ current.estado_str }}</span>
            </div>
            <div class="ticket-description" style="font-size: 13px">
              De: <b>{{ current.tienda_origen_obj.nombre }}</b>
              <br />
              Para: <b>{{ current.tienda_destino_obj.nombre }}</b>
              <br />
              Posición: <b>{{ current.posicion_estacion }}</b>
              <hr />
              <div class="text-left">
                <button @click="refresh_tarima()" class="btn btn-sm btn-dark">
                  Actualizar Info. <i class="fas fa-sync"></i>
                </button>
              </div>
              <!-- Boton de acciones flotantes start  -->
              <div class="btn-group dropleft float-right" style="border-radius: 100px;">
                <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  Opciones&nbsp;<i class="fas fa-plus"></i>
                </button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" @click="finalizarTarima()">
                    <div class="activity-avatar">
                      <i class="fas fa-cash-register"></i> &nbsp;
                      <span class="font-weight-bold">Finalizar Tarima</span>
                    </div>
                  </a>
                  <a class="dropdown-item" @click="Imprimir(current)">
                    <div class="activity-avatar">
                      <i class="fas fa-print"></i>
                      &nbsp;
                      <span class="font-weight-bold">Imprimir</span>
                    </div>
                  </a>
                  <a class="dropdown-item" @click="inventarioXposicionXproducto()">
                    <div class="activity-avatar">
                      <i class="fa fa-cubes"></i>
                      &nbsp;
                      <span class="font-weight-bold">Inv de posición producto</span>
                    </div>
                  </a>
                  <a class="dropdown-item" @click="anularTarima()">
                    <div class="activity-avatar">
                      <i class="fas fa-ban"></i>
                      &nbsp;
                      <span class="font-weight-bold">Anular Tarima</span>
                    </div>
                  </a>
                </div>
              </div>

              <!-- Boton de acciones flotantes END  -->
              <br><br>
              <ModalAsignarProductosATarimaComponent :id_tarima="current.id" v-if="current.estado == 'A'"
                @refresh_tarima="refresh_tarima" @refresh_tarima_finalizada="regresarClick()" />
            </div>
          </div>
          <!--START - Projects list-->
          <div v-if="!cambiar_UiTabla" class="projects-list support-ticket">
            <div class="project-box" v-for="detalle in current.detalle" :key="detalle.id"
              style="background-color: rgb(242, 236, 255)" @click="abrirModalDetalle(detalle)">
              <div class="project-head" style="padding-right: 1em; padding-left: 1em">
                <div class="project-title" style="color: rgb(62, 34, 118)">
                  <h5 style="color: rgb(62, 34, 118)">{{ detalle.producto_obj.sku }}</h5>
                  {{ detalle.producto_obj.nombre }}
                </div>
                <div class="badge badge-dark" v-if="detalle.producto_obj.categoria">
                  {{ detalle.producto_obj.categoria.nombre }}
                </div>
                <br />
                <br />
                <div class="badge badge-default" v-for="_barra in detalle.producto_obj.barras" :key="_barra"
                  style="color: rgb(62, 34, 118)">
                  {{ _barra }}
                </div>
              </div>
              <div class="project-info">
                <div class="row align-items-center">
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col-6">
                        <div class="el-tablo highlight">
                          <div class="label">Total Enviada</div>
                          <h5 style="color: rgb(62, 34, 118)">
                            {{ detalle.total_enviada }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="el-tablo highlight">
                          <div class="label">Total Recibida</div>
                          <h5 style="color: rgb(62, 34, 118)">
                            {{ detalle.total_recibida }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--END - Projects list-->
          <!-- Tabla Mini para detalle de prodcuto en la tarima-->
          <div v-if="cambiar_UiTabla">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr class="project-box" v-for="det in current.detalle" :key="det.id"
                  style="background-color: rgb(242, 236, 255)">
                  <td>
                    <div class="value">
                      <small class="font-weight-bold">{{ det.producto_obj.sku }}</small>
                    </div>
                    <small>
                      <div class="value">
                        {{ det.producto_obj.nombre }}
                      </div>
                    </small>
                    Total enviada:
                    <span class="sub-value font-weight-bold text-success">
                      {{ det.total_enviada }}
                    </span>
                  </td>
                  <td>
                    <div class="badge badge-info" v-if="det.producto_obj.categoria">
                      {{ det.producto_obj.categoria.nombre }}
                    </div>
                    <br />
                    Total Recibida:
                    <span class="sub-value font-weight-bold" style="color: blue">
                      {{ det.total_recibida }}
                      <i v-if="det.total_enviada == det.total_recibida" class="fas fa-check"></i>
                    </span>
                    <br />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- aqui termina la tabla mini-->
        </div>
      </div>
      <ModalEntarimarComponentDevolucion v-if="current.estado == 'A'" :tarima="current"
        @refresh_tarima="refresh_tarima" />
      <InventarioPosicionProductoModalComponent />
    </div>
    <!-- Modal -->
    <div class="modal fade" id="modalOpciones" tabindex="-1" role="dialog" aria-labelledby="modalOpciones"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Opciones</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <button class="btn btn-danger btn-block" @click="deleteDetalle(detalle)">
                  <i class="fas fa-minus-square"></i>
                  &nbsp;Eliminar Linea
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">
              Cerrar &nbsp;<i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalEntarimarComponentDevolucion from "@/components/wms/devoluciontarima/ModalEntarimarComponentDevolucion";
import ModalAsignarProductosATarimaComponent from "@/components/wms/devoluciontarima/ModalAsignarProductosATarimaComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import InventarioPosicionProductoModalComponent from "@/components/commons/InventarioPosicionProductoModalComponent";

export default {
  components: {
    ModalEntarimarComponentDevolucion,
    ModalAsignarProductosATarimaComponent,
    InventarioPosicionProductoModalComponent,
  },
  props: {
    current: {
      type: Object,
    },
  },
  data() {
    return {
      detalle: "",
      cambiar_UiTabla: false,
    };
  },
  mounted() { },
  methods: {
    inventarioXposicionXproducto() {
      $("#modalInventarioXposicionXproducto").modal("show");
    },
    cambiarUiTabla() {
      let self = this;
      self.cambiar_UiTabla = !self.cambiar_UiTabla;
    },
    finalizarTarima() {
      let self = this;
      Notifications.alert.confirm(
        "Finalizar carga de tarima",
        "¿Esta seguro(a)?",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "tarima",
            self.current.id,
            "finalizar_tarima",
            {}
          )
            .then((res) => {
              self.regresarClick();

              Notifications.toast.success(
                "Finalizar carga de tarima",
                "Realizado correctamente."
              );
            })
            .catch((err) => {
              console.log(err.response.data);
              if (err.response.data.detail) {
                Notifications.toast.error(
                  "Finalizar tarima devolución",
                  err.response.data.detail
                );
              }
            });
        }
      );
    },
    anularTarima() {
      let self = this;
      Notifications.alert.confirm(
        "Anular Tarima",
        "Esta seguro que quiere anular la tarima?",
        "si, Anular",
        function () {
          DynamicService.postAction("wms", "tarima", self.current.id, "anular").then(
            (response) => {
              Notifications.alert.success(
                "Anular Tarima",
                "la tarima fue anulada con exito"
              );
              console.log("1");
              self.regresarClick();
              console.log("2");
            }
          );
        }
      );
    },
    abrirModalDetalle(detalle) {
      this.detalle = detalle;
      $("#modalOpciones").modal("show");
    },
    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar Linea",
        "¿esta seguro(a)?",
        "Si",
        function () {
          DynamicService.postAction(
            "wms",
            "tarima",
            self.current.id,
            "eliminar_detalle_tarima",
            {
              id: detalle.id,
            }
          )
            .then((response) => {
              Notifications.alert.success("Eliminar Linea", "Se realizó correctamente");
              $("#modalOpciones").modal("hide");
              self.refresh_tarima();
            })
            .catch((error) => {
              Notifications.alert.error("Eliminar Linea", error.response.data.detail);
            });
        }
      );
    },
    Imprimir(current) {
      let self = this;
      self.id = current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      current;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/tarima/tarima.jrxml&id=${self.id}`
      );
    },
    regresarClick() {
      this.$emit("regresar");
    },
    refresh_tarima() {
      this.$emit("seleccionarTarima", this.current.id);
    },
  },
};
</script>
